import { render, staticRenderFns } from "./KnowledgeContentDesktopView.vue?vue&type=template&id=f27c6750&"
import script from "./KnowledgeContentDesktopView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports